import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { useAdminCheck } from '@/hooks/useAdminCheck';

export default function AdminProtected({ children }: { children: JSX.Element }) {
  const { loading, user } = useAuth();
  const { isAdmin, loading: adminLoading } = useAdminCheck();

  if (loading || adminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: 'hsl(var(--bg-app))' }}>
        <div className="text-ivory/60">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/signin" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
